import { WarehouseType } from '@elementary/common-ui/types';
import {
  IntegrationType,
  ConditionalOperator,
  QualityDimension,
} from './types';

export const qualityDimensions: QualityDimension[] = [
  'completeness',
  'uniqueness',
  'freshness',
  'validity',
  'accuracy',
  'consistency',
];

export const conditionalOperators: ConditionalOperator[] = [
  '>',
  '<',
  '=',
  '>=',
  '<=',
  '!=',
];

export const alertIntegrationLabel: Record<IntegrationType, string> = {
  slack: 'Slack',
  pager_duty: 'Pager Duty',
  microsoft_teams: 'Teams',
  microsoft_teams_bot: 'Teams (Bot)',
  opsgenie: 'Opsgenie',
  email: 'Email',
};

export const anomalyDirectionOptions = [
  { value: 'BOTH', label: 'spikes and drops' },
  { value: 'DROP', label: 'only drops' },
  { value: 'SPIKE', label: 'only spikes' },
];

export const detectionPeriodOptions = [
  { value: 'hour', label: 'hours' },
  { value: 'day', label: 'days' },
];

export const EDITABLE_ASSET_TYPES = ['model', 'source'];

export const AutomatedTestSeverities = {
  ERROR: 10,
  WARN: 1,
};

export const CLOUD_TESTS_UNSUPPORTED_WAREHOUSES: WarehouseType[] = [
  'postgres',
  'clickhouse',
  'fabric',
];

export const CLOUD_TESTS_PARTIAL_SUPPORT_WAREHOUSES: WarehouseType[] = [
  'athena',
  'dremio',
];

export const sensitivityOptions = [
  { value: 'low', label: 'Low' },
  { value: 'medium', label: 'Medium' },
  { value: 'high', label: 'High' },
];

export const trainingPeriodOptions = [
  { value: 'day', label: 'days' },
  { value: 'week', label: 'weeks' },
  { value: 'month', label: 'months' },
];

export const pipelineThresholdUnitOptions = [
  { value: 'second', label: 'seconds' },
  { value: 'minute', label: 'minutes' },
  { value: 'hour', label: 'hours' },
];

export const TRAINING_PERIOD_LIMITS: Record<
  string,
  { min: number; max: number }
> = {
  day: { min: 7, max: 90 },
  week: { min: 1, max: 12 },
  month: { min: 1, max: 3 },
};
